import { useMutation } from "@tanstack/react-query";
import { useCallback } from "react";
import { useAuth0 } from "@auth0/auth0-react";

import { PostAcceptedPools } from "../../api/api";

type AcceptedPoolsResult = {
  status: string;
  Msg?: string;
  errorCode?: string;
};

type AcceptedPoolsPayload = {
  urls: string[];
};

export const usePostAcceptedPools = () => {
  const { getAccessTokenSilently } = useAuth0();

  const mutation = useMutation({
    mutationFn: ({
      urls,
      token,
    }: AcceptedPoolsPayload & {
      token: string;
    }): Promise<AcceptedPoolsResult> =>
      PostAcceptedPools(token, {
        urls,
      }),

    onSuccess: (data) => {
      console.log("data", data);
    },

    onError: (error) => {
      console.error(
        "Error performing miner operations:",
        error
      );
    },
  });

  const mutateWithToken = useCallback(
    async (
      { urls }: AcceptedPoolsPayload,
      options?: {
        onSuccess?: (data: AcceptedPoolsResult) => void;
        onError?: (error: any) => void;
        onSettled?: () => void;
      }
    ) => {
      const token = await getAccessTokenSilently();
      console.log(urls);
      mutation.mutate(
        {
          urls,
          token,
        },
        {
          onSuccess: options?.onSuccess,
          onError: options?.onError,
          onSettled: options?.onSettled,
        }
      );
    },
    [getAccessTokenSilently, mutation]
  );

  return { ...mutation, mutate: mutateWithToken };
};
